<template>
<!--  精彩预告-->
  <div id="ad-block-3">
    <div class="justify-align">
      <div class="title-box">
        <div class="title-txt">{{param.title}}</div>
        <div class="title-box-line"></div>
      </div>
      <!--        <div class="right-box">-->
      <!--          查看全部 >-->
      <!--        </div>-->
    </div>
    <div class="foreshow-list-box">
      <template v-for="(items,index) in param.data">
        <div class="one-box justify-align" :key="index" v-if="items.number==1">
          <van-swipe class="my-swipe" :autoplay="3000" :show-indicators="false">
            <van-swipe-item class="factory-item-a" v-for="(item,i) in items.items" :key="i" @click="goNextPage(item)">
<!--              <router-link :to="item.url">-->
                <img :src="item.image" alt="" />
<!--              </router-link>-->
            </van-swipe-item>
          </van-swipe>
        </div>
        <div class="two-box justify-align" :key="index" v-if="items.number==2">
          <swiper class="swiper" :options="swiperOptionTwo">
            <swiper-slide class="factory-item-a" v-for="(item,i) in items.items" :key="i">
              <a :href="item.url">
                <img :src="item.image" alt="" />
              </a>
            </swiper-slide>
          </swiper>
        </div>
        <div class="three-box justify-align " :key="index" v-if="items.number==3">
          <swiper class="swiper" :options="swiperOptionThree">
            <swiper-slide class="factory-item-a" v-for="(item,i) in items.items" :key="i">
              <a :href="item.url">
                <img :src="item.image" alt="" />
              </a>
            </swiper-slide>
          </swiper>
        </div>
        <div class="four-box justify-align " :key="index" v-if="items.number==4">
          <swiper class="swiper" :options="swiperOptionFour">
            <swiper-slide class="factory-item-a" v-for="(item,i) in items.items" :key="i">
              <a :href="item.url">
                <img :src="item.image" alt="" />
              </a>
            </swiper-slide>
          </swiper>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import {Swiper, SwiperSlide, directive} from 'vue-awesome-swiper'
import 'swiper/swiper-bundle.css'
export default {
  name: "previewItem",
  props:['param'],
  components: {
    Swiper,
    SwiperSlide,
  },
  data(){
    return {
      swiperOptionOne: {
        slidesPerView: 1,
        observer: true,
        observeParents: true,
        loop:false,
        speed: 3000,
        autoplay: 3000
      },
      swiperOptionTwo: {
        slidesPerView: 2,
        observer: true,
        observeParents: true,
        spaceBetween: 5,
        loop:false,
        speed: 3000,
        autoplay: 3000
      },
      swiperOptionFour: {
        observer: true,
        observeParents: true,
        slidesPerView: 4,
        spaceBetween: 5,
        loop:false,
        speed: 3000,
        autoplay: 3000
      },
      swiperOptionThree: {
        observer: true,
        observeParents: true,
        slidesPerView: 3,
        spaceBetween: 5,
        loop:false,
        speed: 3000,
        autoplay: 3000
      },
    }
  },
  methods: {
    goNextPage(item){
      console.log(item)
      var url = item.url
      let urlPage = url.split('https')
      // console.log(urlPage)
      if (urlPage.length==2){
        // console.log(item.uri)
        window.open(item.url)
        // window.open('https://kuailong.itos.cn/Wechat/Index/index.html?state=0dfc590eedcfb742c6ef1ac247259760cb886062')
      } else {
        // console.log(1111)
        this.$router.push({path: url})
      }
    },
    goTest(){
      this.$router.push({name:'activityTheme',params: {type:'activity'}});
    },
  }
}
</script>

<style lang="scss" scoped>
.title-box{
  display: inline-block;font-size: 32px;color: #1D1D1D;font-weight: bold;margin-left: 24px;
  position: relative;padding: 22px 0;
  .title-txt{
    width: 143px;text-align: center;
  }
  .title-box-line{
    width: 143px;
    height: 15px;
    background: #FEDC32;
    border-radius: 8px;margin-top: -15px;
  }
}
.one-box{
  border-radius: 12px;max-height:400px;
  overflow: hidden;margin-bottom: 12px;
}
.one-box img{
  max-height:400px;width: 100%;
}
.foreshow-list-box{
  .factory-item{
    img{
      width: 100%;height: 200px;border-radius: 12px;
    }

  }
  .two-box{
    overflow: hidden;margin-bottom: 12px;
    .factory-item-a{
      width: 49%;display: block;
      img{
        width: 100%;height: 200px;border-radius: 12px;
      }
    }
  }
  .three-box{
    overflow: hidden;margin-bottom: 12px;
    .factory-item-a{
      width:32%;display: block;
      img{
        width: 100%;height: 200px;border-radius: 12px;
      }
    }
  }
  .four-box{
    margin-bottom: 12px;
    .factory-item-a{
      width:24%;display: block;
      img{
        width: 100%;height: 200px;border-radius: 12px;
      }
    }
  }
}
#ad-block-3{
  width: 696px;margin: auto auto;
  .right-box{
    font-size: 28px;color: #B2B5B1;font-weight: bold;
  }
  .list-factory-box{
    .factory-item{display: block;
      padding: 24px;
      background: #FFFFFF;
      border-radius: 12px;margin-bottom: 22px;
      .factory-info{
        .factory-info-img{
          width: 100px;
          height: 100px;
          border-radius: 50%;background: #cccccc;
        }
        .factory-info-txt{
          text-align: left;font-weight: 400;
          color: #B6B6B6;
          font-size: 24px;margin-left: 20px;
          .name{
            font-weight: bold;
            color: #272727;font-size: 28px;margin-bottom: 10px;
          }
        }
      }
      .info-course-box{
        margin-top: 26px;position: relative;
        .course-img{
          width: 250px!important;
          height: 150px;
          background: #8C8C8C;
          border-radius: 10px;display: block;margin-right: 20px;
        }
        .course-info{
          .title-box-course{
            font-size: 24px;
            font-weight: 400;
            color: #1D1D1D;
            line-height: 36px;text-align: left;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            line-clamp: 2;
          }
          .tag-box{
            position: absolute;
            bottom: 0;left: 260px;width: 390px;
            .tag-item{
              padding: 5px 10px;

              background: #FFF4BE;font-size: 18px;color: #EDA10E;
              border-radius: 5px;margin-left: 10px;
            }
          }
        }
      }
    }
  }

}
</style>
